import { ButtonStateEnum } from '@/features/ui/buttons/constants'
import { useState } from 'react'

export const useEnabledButtonState = () => {
    const [isHovered, setIsHovered] = useState(false)
    const [isPressed, setIsPressed] = useState(false)

    const getState = () => {
        if (isPressed) return ButtonStateEnum.Pressed

        if (isHovered) return ButtonStateEnum.Hovered

        return ButtonStateEnum.Default
    }

    const handleHoverIn = () => setIsHovered(true)

    const handleHoverOut = () => setIsHovered(false)

    const handlePressIn = () => setIsPressed(true)

    const handlePressOut = () => setIsPressed(false)

    return {
        state: getState(),
        eventHandlers: {
            onHoverIn: handleHoverIn,
            onHoverOut: handleHoverOut,
            onPressIn: handlePressIn,
            onPressOut: handlePressOut,
        },
    } as const
}
